import { stepStateMachine } from '@bingads-webui-campaign-react/step-wizard-machine';
import { withRecommendationContext } from '@bingads-webui-campaign-react/perf-max-recommendation';
import { withBannerService } from '@bingads-webui/inline-copilot';
import { STEP_PATHS } from '../../common/constants';
import { getErrorsPlaceholders, initialAssetGroupViewModel } from '../../model/asset-group';
import { patchStepsData, loadData, saveData, needsLoading, needsSaving, isValid, isDirty, clearErrors } from './step-campaign-asset-group-impl';
import { StepAssetGroupShell } from './step-campaign-asset-group';

export const stepAssetGroupWizardConfig = {
  id: STEP_PATHS.ASSET_GROUP,
  title: _TL_('Asset group'),
  StepMachine: stepStateMachine,
  StepMachineOptions: (stepInfo, initialStepsData) => ({
    machineId: STEP_PATHS.ASSET_GROUP,
    initialContext: {
      id: stepInfo.id,
      stepInfo,
      stepsData: initialStepsData,
      data: {
        assetGroup: initialAssetGroupViewModel,
        extensionsAssociations: {},
        ...getErrorsPlaceholders(),
      },
      invalidSaveAttempt: 0,
    },
    actions: {
      patchStepsData,
      clearErrors,
    },
    guards: {
      needsLoading,
      needsSaving,
      isValid,
      isDirty,
    },
  }),
  StepComponent: withBannerService(withRecommendationContext(StepAssetGroupShell)),
  canNavigateBackWithoutSaving: true,
  stepRepositoryConfig: {
    saveData,
    loadData,
  },
};
